import React from "react";
import { WheelsResults } from "./wheels-results.jsx";
import { WheelsLoadMore } from "./wheels-loadmore.jsx";
import { WheelsFilters } from "./wheels-filters.jsx";
import { debounce } from "../../utils/debounce.js";
import { Localize } from "../shared/localize.js";
import { MapQueryStringToObject, ObjectToQueryString } from "../../utils/urls.js";
// import fil from "date-fns/esm/locale/fil";

class WheelsDaddy extends React.Component {

  constructor(props) {
    super(props);

    var wheels = (props.wheels) ? props.wheels : [];

    var brands = [], diameters = [], steelOrAlloy = [];
    if (wheels) {
      diameters = wheels.map((w) => w.Diameters.map((d) => d.Diameter)).reduce((a, v) => a.concat(v), []);
      diameters = [...(new Set(diameters.map((w) => w)))];
      diameters.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
    }

    const parsed = MapQueryStringToObject(window.location);

    var filters = {
      brand: "",
      diameter: props.selectedDiameter,
      diameters: diameters.map((d) => { return { diameter: d, active: true } }),
      steelOrAlloy: [{ steelOrAlloy: Localize.L("Ferro"), active: true }, { steelOrAlloy: Localize.L("Lega"), active: true }],
      page: parsed.page || 1
      // currentLastPageDisplayed: 1
    };

    //const parsed = queryString.parse(location.search);

    if (parsed.diameters) {

      // convertiamo il filtro parsato in un array

      var diameters = parsed.diameters;
      if (diameters.constructor !== Array) {
        diameters = diameters.split(",");
      }

      filters.diameters = filters.diameters.map((d) => diameters.some((p) => p == d.diameter) ? d : { ...d, active: false });
    }
    if (parsed.steeloralloy) {
      filters.steelOrAlloy = filters.steelOrAlloy.map((d) => parsed.steeloralloy == d.steelOrAlloy.toLowerCase() ? d : { ...d, active: false });
    }
    if (parsed.brand) {
      var brands = [...(new Set(wheels.map((w) => w.Brand)))];
      filters.brand = brands.find((b) => parsed.brand == b.toLowerCase());
    }

    var initialState = this.resetState(filters);
    this.state = { ...initialState };
  };

  resetState = (newFilters) => {
    var filters = newFilters;

    var viewport = {
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
      clientWidth: document.body.clientWidth,
      clientHeight: document.body.clientHeight
    };

    var HM_COLS = 4;

    if (viewport.clientWidth < 558) {
      HM_COLS = 1;
    }
    else if (viewport.clientWidth < 768) {
      HM_COLS = 2;
    }
    else if (viewport.clientWidth < 992) {
      HM_COLS = 3;
    }

    var iDisplayStart = 0;
    //var iDisplayLength = 1 * this.props.iDisplayLength;
    var iDisplayLength = this.closestDisplayLength(1 * this.props.iDisplayLength, HM_COLS);

    var newState = {
      iDisplayStart: iDisplayStart,
      iDisplayLength: iDisplayLength,

      HM_COLS: HM_COLS,

      filters: { ...filters },

      viewport: viewport
    };

    //first let's filter all the wheels available for this car by the currently set filters
    var wheels = (this.props.wheels) ? this.props.wheels : [];
    var filtered_wheels = wheels.filter((w) =>
      (
        filters.steelOrAlloy.some((f) => f.steelOrAlloy == Localize.L("Lega") && f.active) && w.ProductTypeId == 2
        ||
        filters.steelOrAlloy.some((f) => f.steelOrAlloy == Localize.L("Ferro") && f.active) && w.ProductTypeId == 3
      ) && (
        w.Diameters.some((d) => filters.diameters.some((dd) => dd.diameter == d.Diameter && dd.active))
      ) && (
        !filters.brand || filters.brand == w.Brand
      )
    );

    // se è richiesto di resettare i filtri sui diametri

    if (((window || {}).resetDiametersFilters || "") != "") {

      // riabilita tutti i filtri sui diametri

      filters.diameters.every((dd) => dd.active = true);

      // reinizializziamo i dati

      wheels = wheels.filter((w) => (
          filters.steelOrAlloy.some((f) => f.steelOrAlloy == Localize.L("Lega") && f.active) && w.ProductTypeId == 2
          ||
          filters.steelOrAlloy.some((f) => f.steelOrAlloy == Localize.L("Ferro") && f.active) && w.ProductTypeId == 3
        ) && (
          w.Diameters.some((d) => filters.diameters.some((dd) => dd.diameter == d.Diameter && dd.active))
        ) && (
          !filters.brand || filters.brand == w.Brand
        )
      );
    }
    else {
      wheels = filtered_wheels;
    }

    //temptative
    wheels.sort((a, b) => {
      var aMin = Math.min(...a.Diameters.filter((d) => filters.diameters.some((dd) => dd.diameter == d.Diameter && dd.active)).map((d) => d.BestPrice));
      var bMin = Math.min(...b.Diameters.filter((d) => filters.diameters.some((dd) => dd.diameter == d.Diameter && dd.active)).map((d) => d.BestPrice));
      return aMin < bMin ? -1 : aMin > bMin ? 1 : 0;
    });
    //temptative

    if (wheels) {
      //now we need to redetermine the possible set of brands and diameters for the filtered list of wheels
      var brands = [...(new Set(wheels.map((w) => w.Brand)))];
      var diameters = wheels.map((w) => w.Diameters.map((d) => d.Diameter)).reduce((a, v) => a.concat(v), []);
      diameters = [...(new Set(diameters.map((w) => w)))];
      var steelOrAlloy = [...(new Set(wheels.map((w) => w.ProductTypeId == 2 ? Localize.L("Lega") : w.ProductTypeId == 3 ? Localize.L("Ferro") : "")))];
      brands.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
      diameters.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);

      //now we build the list of visible pages
      var allLines = [];
      //var currentLastPageDisplayed = filters.currentLastPageDisplayed;
      //while (currentLastPageDisplayed-- > 0) {
      //  var gap = currentLastPageDisplayed * iDisplayLength;

      var totPages = parseInt(wheels.length / this.props.iDisplayLength) + (wheels.length % this.props.iDisplayLength == 0 ? 0 : 1);

      var page = filters.page > totPages ? totPages : filters.page;

      page = page > 0 ? page : 1;

      var gap = (page - 1) * this.props.iDisplayLength;

      gap = gap >= 0 ? gap : 0;

      var visibleWheels = wheels.slice(iDisplayStart + gap, iDisplayLength + gap);

      //here we set the selectedDiameter for every single wheel taking into account the wheel available diameters and the selected diameters in the filters
      visibleWheels = visibleWheels.map((w) => {
        return {
          ...w,
          selectedDiameter: w.Diameters.filter((d) => filters.diameters.some((dd) => dd.diameter == d.Diameter && dd.active)).sort((a, b) => a.BestPrice < b.BestPrice ? -1 : a.BestPrice > a.BestPrice ? 1 : 0)[0].Diameter
        };
        //return {
        //  ...w,
        //  selectedDiameter:
        //    w.Diameters.some((d) => d.Diameter == filters.diameter && filters.diameters.some((dd) => dd.diameter == filters.diameter && dd.active)) ? filters.diameter
        //      : w.Diameters.filter((d) => filters.diameters.some((dd) => dd.diameter == d.Diameter && dd.active)).sort((a, b) => a.BestPrice < b.BestPrice ? -1 : a.BestPrice > a.BestPrice ? 1 : 0)[0].Diameter
        //};
      });
      if (visibleWheels.length > 0) {
        allLines.unshift(visibleWheels);
      }

      newState = {
        ...newState,
        hmTotalWheelsForThisCar: this.props.wheels.length,
        hmFilteredWheelsForThisCar: wheels.length,
        allLines: allLines,
        filters: {
          ...filters,
          page: page,
          values: {
            brands: brands,
            diameters: diameters,
            steelOrAlloy: steelOrAlloy
          }
        }
      };
    } else {
      //newState = {
      //  ...newState,
      //  hmTotalWheelsForThisCar: this.props.wheels.length,
      //  hmFilteredWheelsForThisCar: wheels.length,
      //  allLines: allLines,
      //  filters: {
      //    ...filters,
      //    values: {
      //      brands: brands,
      //      diameters: diameters,
      //      steelOrAlloy: steelOrAlloy
      //    }
      //  }
      //};
    }

    return newState;
  }

  closestDisplayLength = (a, b) => {
    var c1 = a - (a % b);
    var c2 = (a + b) - (a % b);
    if (a - c1 > c2 - a) {
      return c2;
    } else {
      return c1;
    }
  }

  resizeListener = (e) => {
    var filters = this.state.filters;
    var newState = this.resetState(filters);
    this.setState({ ...this.state, ...newState });
  }

  componentDidMount() {
    // window.addEventListener('scroll', this.onScroll, false);
    window.addEventListener('resize', this.resizeListener, true);
  }

  componentWillUnmount() {
    // window.removeEventListener('scroll', this.onScroll, false);
    window.removeEventListener('resize', this.resizeListener, true);
  }

  componentDidUpdate(propsPrec) {

    // se sono cambiate le wheels gli facciamo ricalcolare le linee

    if (this.props.wheels !== propsPrec.wheels) {

      var filters = this.state.filters;

      //const parsed = queryString.parse(location.search);
      const parsed = MapQueryStringToObject(window.location);

      if (parsed.diameters) {

        // convertiamo il filtro parsato in un array

        var diameters = parsed.diameters;
        if (diameters.constructor !== Array) {
          diameters = diameters.split(",");
        }

        filters.diameters = filters.diameters.map((d) => diameters.some((p) => p == d.diameter) ? d : { ...d, active: false });
      }
      else {
        var diameters = [];

        if (this.props.wheels) {
          diameters = this.props.wheels.map((w) => w.Diameters.map((d) => d.Diameter)).reduce((a, v) => a.concat(v), []);
          diameters = [...(new Set(diameters.map((w) => w)))];
          diameters.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
        }

        filters.diameter = this.props.selectedDiameter;
        filters.diameters = diameters.map((d) => { return { diameter: d, active: true } });
      }
      if (parsed.steeloralloy) {
        filters.steelOrAlloy = filters.steelOrAlloy.map((d) => parsed.steeloralloy == d.steelOrAlloy.toLowerCase() ? d : { ...d, active: false });
      }
      else {
        filters.steelOrAlloy = [{ steelOrAlloy: Localize.L("Ferro"), active: true }, { steelOrAlloy: Localize.L("Lega"), active: true }];
      }
      if (parsed.brand) {
        var brands = [...(new Set(wheels.map((w) => w.Brand)))];
        filters.brand = brands.find((b) => parsed.brand == b.toLowerCase());
      }
      else {
        filters.brand = "";
      }

      var newState = this.resetState(filters);
      this.setState({ ...this.state, ...newState });
    }
  }

  //onScroll = debounce(() => {
  //  if (
  //    (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 500)
  //  ) {
  //    if ((this.state.allLines.length * this.state.iDisplayLength) < this.state.hmFilteredWheelsForThisCar) {
  //      console.log("window.innerHeight", window.innerHeight);
  //      console.log("window.scrollY", window.scrollY);
  //      console.log("document.body.offsetHeight", document.body.offsetHeight);
  //      console.log("document.body.scrollHeight", document.body.scrollHeight);
  //      console.log("document.height", document.height);
  //      console.log("=============================");

  //      var filters = this.state.filters;
  //      filters.currentLastPageDisplayed++;
  //      var newState = this.resetState(filters);

  //      this.setState({ ...this.state, ...newState });
  //    }
  //  }
  //})

  gotoPage = (e, page) => {
    var filters = this.state.filters;
    filters.page = page;
    var newState = this.resetState(filters);

    const parsed = MapQueryStringToObject(window.location);

    var qs = { ...parsed };
     
    // ricalcola la pagina

    qs.page = filters.page;

    var url = (location.pathname + "?" + ObjectToQueryString(qs)).toLowerCase();

    window.history.pushState("", "", url);

    this.setState({ ...this.state, ...newState }, () => {
      if ((this.state.allLines != null) && (this.state.allLines.length == 1)) {
        var siteGTag = window.site_config.gtag;

        var items = this.state.allLines[0].map(function(item, index) {
          return {
            item_id: item.WheelId,
            item_name: item.Brand + " " + item.Model,
            item_variant: item.Color + " " + item.Holes + " fori",
            googleId: item.googleId,
            currency: "EUR",
            price: item.GATRAI,
            bestprice: item.BestPrice,
            GATRAI: item.GATRAI,
            quantity: 1,
            item_brand: item.Brand,
            index: index,
            item_category: "wheel"
          };
        });

        if (items.length > 0) {
          gtag("event", "view_item_list", {
            // send_to: siteGTag.GA4IDAnalytics,
            ecommerce: {
              item_list_id: url,
              item_list_name: url,
              items: items.map((e) => {
                return {
                  item_id: e.googleId,
                  item_name: e.item_name,
                  item_variant: e.item_variant,
                  currency: "EUR",
                  price: parseFloat(e.GATRAI),
                  bestprice: e.bestprice,
                  quantity: e.quantity,
                  index: e.index,
                  item_category: e.item_category,
                  item_brand: e.item_brand
                };
              })
            }
          });

          //gtag("event", "view_item_list", {
          //  send_to: siteGTag.UIDAnalytics,
          //  items: items.map((e) => {
          //    return {
          //      id: e.googleId,
          //      name: e.item_name,
          //      variant: e.item_variant,
          //      brand: e.item_brand,
          //      price: e.GATRAI,
          //      category: e.item_category,
          //      list_name: "Wheel's Search Results",
          //      list_position: e.index
          //    };
          //  })
          //});
        }
      }
    });
  };

  handleClick = (e) => {
    var pages = this.state.pages;

    if (pages && pages[0]) {
      console.log(pages);

      var currentPage = pages.find((p) => p.active);
      var nextPage = pages.find((p) => p.pagenr > currentPage.pagenr);

      if (nextPage) {
        var filters = Object.assign({}, this.props.filters, { iDisplayStart: nextPage.iDisplayStart });

        var xhr = new HttpRequest("POST", '/wheels/loadmore', "application/json");

        return xhr.send(filters)
          .then((response) => {
            var json = response.json;
            if (json.message || json.exception || json.error) {
              alert(json.message || json.exception || json.error);
            }
            var allLines = this.state.allLines;
            allLines.push(json.lines);

            this.setState({
              count: json.count,
              pages: json.pages,
              allLines: allLines
            });
          }, (error) => { alert(error); });
      }
    }
  };

  localWheelSelectDiameter = (wheel, diameter) => {
    this.state.allLines.forEach((lines) => {
      lines.forEach((l) => {
        if (l.DetailsUrl == wheel.DetailsUrl) {
          l.selectedDiameter = diameter;
        }
      });
    });

    this.setState({
      allLines: this.state.allLines
    });
  }

  handleChange = (e, diameter, steelOrAlloy) => {
    if (e) e.preventDefault();

    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    var filters = { ...this.state.filters };
    if (diameter) {
      filters = { ...filters, diameters: filters.diameters.map((d) => { return d.diameter == diameter ? { ...d, active: !d.active } : d }) };
    } else if (steelOrAlloy) {
      filters = { ...filters, steelOrAlloy: filters.steelOrAlloy.map((d) => { return d.steelOrAlloy == steelOrAlloy ? { ...d, active: !d.active } : d }) };
    } else {
      filters = { ...filters, [name]: value };
    }

    //const parsed = queryString.parse(location.search);
    const parsed = MapQueryStringToObject(window.location);

    var qs = { ...parsed };

    // ricalcola i diametri attivi

    qs.diameters = filters.diameters.filter((d) => d.active).map((d) => d.diameter);

    if (filters.steelOrAlloy.every((d) => !d.active)) {
      qs.steeloralloy = null;
    }
    else if (filters.steelOrAlloy.some((d) => !d.active)) {
      qs.steeloralloy = filters.steelOrAlloy.filter((d) => d.active).map((d) => d.steelOrAlloy);
    }
    else {
      delete qs.steeloralloy;
    }
    if (filters.brand) {
      qs.brand = filters.brand;
    }

    //var url = location.pathname + "?" + queryString.stringify(qs).toLowerCase();
    var url = (location.pathname + "?" + ObjectToQueryString(qs)).toLowerCase();

    //console.log("window.history.pushState", url);
    window.history.pushState("", "", url);

    var newState = this.resetState(filters);

    this.setState({ ...this.state, ...newState }, () => {
      if ((this.state.allLines != null) && (this.state.allLines.length == 1)) {
        var siteGTag = window.site_config.gtag;

        var items = this.state.allLines[0].map(function (item, index) {
          return {
            item_id: item.WheelId,
            item_name: item.Brand + " " + item.Model,
            item_variant: item.Color + " " + item.Holes + " fori",
            googleId: item.googleId,
            currency: "EUR",
            price: item.GATRAI,
            bestprice: item.BestPrice,
            GATRAI: item.GATRAI,
            quantity: 1,
            item_brand: item.Brand,
            index: index,
            item_category: "wheel"
          };
        });

        if (items.length > 0) {
          gtag("event", "view_item_list", {
            // send_to: siteGTag.GA4IDAnalytics,
            ecommerce: {
              item_list_id: url,
              item_list_name: url,
              items: items.map((e) => {
                return {
                  item_id: e.googleId,
                  item_name: e.item_name,
                  item_variant: e.item_variant,
                  currency: "EUR",
                  price: parseFloat(e.GATRAI),
                  bestprice: e.bestprice,
                  quantity: e.quantity,
                  index: e.index,
                  item_category: e.item_category,
                  item_brand: e.item_brand
                };
              })
            }
          });

          var a = "";

          //gtag("event", "view_item_list", {
          //  send_to: siteGTag.UIDAnalytics,
          //  items: items.map((e) => {
          //    return {
          //      id: e.googleId,
          //      name: e.item_name,
          //      variant: e.item_variant,
          //      brand: e.item_brand,
          //      price: e.GATRAI,
          //      category: e.item_category,
          //      list_name: "Wheel's Search Results",
          //      list_position: e.index
          //    };
          //  })            
          //});
        }
      }
    });
  }

  pagination = (totElems, page) => {
    var elemXPage = this.props.iDisplayLength;

    var totPages = parseInt(totElems / elemXPage) + (totElems % elemXPage == 0 ? 0 : 1);

    if (isNaN(totPages)) {
      totPages = 1;
    }

    var nPage = parseInt(page);

    if (!isNaN(nPage)) {
      if (nPage > totPages) {
        nPage = totPages;
      }
    }
    else {
      nPage = 1;
    }

    var start = nPage - 2;
    var finish = nPage + 2;

    if (start < 1) {
      finish -= start;
      start = 1;
    }
    if (finish > totPages) {
      start -= (finish - totPages);
      finish = totPages;
      if (start < 1) {
        start = 1;
      }
    }

    var pages = [];

    for (var ii = start; ii <= finish; ii++) {
      pages.push(
        {
          start: (ii - 1) * elemXPage,
          active: (ii == nPage),
          nPage: ii
        });
    }

    var current_decina = parseInt(nPage / 10) * 10;

    var start_decina = current_decina - 20;
    var finish_decina = current_decina + 20;

    var last_decina = parseInt(totPages / 10) * 10;

    if (start_decina < 0) {
      finish_decina += -start_decina;
      start_decina = 10;
    }
    if (finish_decina > last_decina) {
      start_decina -= (finish_decina - last_decina);
      finish_decina = last_decina;
      if (start_decina < 10) {
        start_decina = 10;
      }
    }

    var decinePre = [];
    var decinePost = [];

    for (var jj = start_decina; jj < current_decina; jj += 10) {
      decinePre.push(jj);
    }

    for (var jj = current_decina + 10; jj <= finish_decina; jj += 10) {
      decinePost.push(jj);
    }

    var pagination = {
        elemXPage: elemXPage,

        nPage: nPage,

        totElems: totElems,
        totPages: totPages,

        pages: pages,

        decinePre: decinePre,
        decinePost: decinePost
      };

    return pagination;
  }

  render() {

    var brands = this.state.filters.values.brands,
      diameters = this.state.filters.values.diameters;

    // controlliamo se non vogliamo ne i filtri ne la paginazione utiliziamo la lista delle wheels

    if (this.props.hideFilters && this.props.hideLoadMore) {
      return (
        <div>
          <WheelsResults key={"lines-pro"}
            lines={this.state.allLines[0]}
            filters={this.state.filters}
            HM_COLS={this.state.HM_COLS}
            localWheelSelectDiameter={this.localWheelSelectDiameter}
            car={this.props.car}
            year={this.props.year}
          />
        </div>);
    }

    var lines = [];

    this.state.allLines.forEach((l, i) => {
      lines.push(
        <WheelsResults key={"lines-" + i}
          lines={l}
          filters={this.state.filters}
          HM_COLS={this.state.HM_COLS}
          localWheelSelectDiameter={this.localWheelSelectDiameter}
          car={this.props.car}
          year={this.props.year}
        />
      );
    });

    // ricalcoliamo tutto rispetto a quelli filtrati

    var pagination = this.pagination(this.state.hmFilteredWheelsForThisCar, this.state.filters.page);

    let elements = [];

    elements.push(
      <span key="Pagination_TotalPages" className="text-center btn-big-enough" style={{ color: "#212529", backgroundColor: "#f8f9fa", border: "1px solid lightgray", borderRadius: "3px", display: "inline-block" }}>
        {Localize.L("Pagina")} {pagination.nPage} {Localize.L("di")} {pagination.totPages}
      </span>
    );

    if (pagination.nPage > 1) {
      if (pagination.nPage > 3) {
        elements.push(
          <a key="Pagination_First" className="btn btn-light btn-big-enough" onClick={(e) => this.gotoPage(e, 1)}>{Localize.L("« Prima")}</a >
        );
      }
      elements.push(
        <a key="Pagination_Prec" className="btn btn-light btn-big-enough" onClick={(e) => this.gotoPage(e, (pagination.nPage - 1))}>{Localize.L("«")}</a >
      );

      if (pagination.nPage > 3) {
        elements.push(
          <span key="Pagination_Sep_Prec" className="text-center btn-big-enough" style={{ color: "#212529", backgroundColor: "#f8f9fa", border: "1px solid lightgray", borderRadius: "3px", display: "inline-block" }}>...</span>
        );
      }
    }
    if (pagination.decinePre.length > 0) {
      for (var jj in pagination.decinePre) {
        let decina = pagination.decinePre[jj];
        elements.push(
          <a key={"Pagination_Decina_" + decina} className="btn btn-light btn-big-enough" onClick={(e) => this.gotoPage(e, decina)}>{decina}</a >
        );
      }
      elements.push(
        <span key="Pagination_Decina_Sep_Prec" className="text-center btn-big-enough" style={{ color: "#212529", backgroundColor: "#f8f9fa", border: "1px solid lightgray", borderRadius: "3px", display: "inline-block" }}>...</span>
      );
    }
    for (var jj in pagination.pages) {
      var _page = pagination.pages[jj];
      if (_page.active) {
        elements.push(
          <span key={"Pagination_Page_" + _page.nPage} className="text-center btn-big-enough" style={{ color: "#212529", backgroundColor: "#e2e6ea", border: "1px solid lightgray", borderRadius: "3px", display: "inline-block" }}>{_page.nPage}</span>
        );
      }
      else {
        let pagenr = _page.nPage;
        elements.push(
          <a key={"Pagination_Page_" + _page.nPage} className="btn btn-light btn-big-enough" onClick={(e) => this.gotoPage(e, pagenr)}>{pagenr}</a >
        );
      }
    }
    if (pagination.decinePost.length > 0) {
      elements.push(
        <span key="Pagination_Decina_Sep_Next" className="text-center btn-big-enough" style={{ color: "#212529", backgroundColor: "#f8f9fa", border: "1px solid lightgray", borderRadius: "3px", display: "inline-block" }}>...</span>
      );

      for (var jj in pagination.decinePost) {
        let decina = pagination.decinePost[jj];
        elements.push(
          <a key={"Pagination_Decina_" + decina} className="btn btn-light btn-big-enough" onClick={(e) => this.gotoPage(e, decina)}>{decina}</a >
        );
      }
    }
    if (pagination.nPage < pagination.totPages) {
      if (pagination.nPage < (pagination.totPages - 2)) {
        elements.push(
          <span key="Pagination_Sep_Next" className="text-center btn-big-enough" style={{ color: "#212529", backgroundColor: "#f8f9fa", border: "1px solid lightgray", borderRadius: "3px", display: "inline-block" }}>...</span>
        );
      }
      elements.push(
        <a key="Pagination_Next" className="btn btn-light btn-big-enough" onClick={(e) => this.gotoPage(e, pagination.nPage + 1)}>{Localize.L("»")}</a >
      );
      if (pagination.nPage < (pagination.totPages - 2)) {
        elements.push(
          <a key="Pagination_Last" className="btn btn-light btn-big-enough" onClick={(e) => this.gotoPage(e, pagination.totPages)}>{Localize.L("Ultima »")}</a >
        );
      }
    }

    return (
      <div>
        <WheelsFilters
          car={this.props.car}
          brands={brands}
          diameters={diameters}
          filters={this.state.filters}
          hideFilters={this.props.hideFilters}
          handleChange={this.handleChange}
          year={this.props.year}
        />
        {lines}
        <div className="text-center mx-auto pt-4 pb-5">
          {elements}
        </div>
      </div>
    );

    //<WheelsLoadMore
    //  hmTotalWheelsForThisCar={this.state.hmTotalWheelsForThisCar}
    //  hmFilteredWheelsForThisCar={this.state.hmFilteredWheelsForThisCar}
    //  hmWheelsDisplayedSoFar={this.state.allLines.length * this.state.iDisplayLength}
    //  hideLoadMore={this.props.hideLoadMore}
    //  count={this.state.count}
    //  handleClick={this.handleClick}
    ///>
  }
}

export { WheelsDaddy }